import FlipbookViewer from "../components/FlipbookViewer";

export default function PoolSaltChlorineGenerators() {
  return (
    <div>
      {/* Hero */}
      <section className="relative bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 py-20 md:py-28">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <h1 className="text-3xl md:text-5xl font-bold text-white">SALT CHLORINE GENERATOR</h1>
        </div>
      </section>

      

          {/* Brochure Section */}
          <section className="py-12 md:py-16 bg-gray-50">
              <div className="max-w-[1400px] mx-auto px-4 md:px-8 text-center">
                  <p className="text-sm md:text-base text-gray-700 mb-8">Check out the new Brochure below!</p>
              </div>
              <div className="max-w-[1400px] mx-auto px-4 md:px-8">
                  <FlipbookViewer
                      title="Salt System Brochure"
                      downloadUrl="/images/SaltSystem_brochure.pdf"
          />
          <FlipbookViewer
            title="Guide to Salt Chlorinator"
                      downloadUrl="/images/Hayward_Guide_to_Salt_Chlorination-1.pdf"
          />
        </div>
      </section>
    </div>
  );
}